let n = () => {
  throw new Error("LinkComponent not registered");
};
const e = (o) => {
  n = o;
}, t = () => n;
export {
  t as getLinkComponent,
  e as registerLinkComponent
};
